export const projectsData = [
  {
    id: 1,
    title: "Caméléon",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Le caméléon présenté ici change de couleur à chaque clic sur l'image grâce à un générateur de couleur.",
    img: "./assets/img/cameleon.jpg",
    link: "/projet-cameleon",
  },
  {
    id: 2,
    title: "Bulles",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Dans ce jeu, des bulles sont créées aléatoirement. Il suffit de cliquer sur une bulle pour la faire éclater. Un compteur affiche le nombre de bulles que le joueur est parvenu à faire disparaître.",
    img: "./assets/img/aquarium-vignette.jpg",
    link: "/projet-bulles",
  },
  {
    id: 3,
    title: "To do list",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Ce formulaire permet d'établir une liste de tâches. Les informations saisies sont stockées dans le « local storage » et y restent jusqu’à leur suppression par un clic de l’utilisateur sur les items de la liste.",
    img: "./assets/img/todolist.jpg",
    link: "/projet-to-do-list",
  },
  {
    id: 4,
    title: "Minuteur",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Ce compte à rebours propose de saisir un nombre de minutes dans un formulaire. Après validation par l’utilisateur, le temps restant est affiché.  La mention «C’est terminé» apparaît lorsque le temps est écoulé.",
    img: "./assets/img/minuteur.jpg",
    link: "/projet-minuteur",
  },
  {
    id: 5,
    title: "Vacances",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Ce formulaire de réservation permet d’entrer une date de début et une date de fin de séjour. Il affiche également le prix d’une nuitée ainsi que le prix total du séjour selon le nombre de nuits sélectionné.",
    img: "./assets/img/vacances.jpg",
    link: "/projet-vacances",
  },
  {
    id: 6,
    title: "Pays du monde",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Cette application React est reliée à une base de données de pays depuis une API. L’utilisateur peut trier et filtrer les pays par ordre croissant et décroissant de population ou encore par ordre alphabétique.",
    img: "./assets/img/pays.jpg",
    link: "/projet-pays-du-monde",
  },
  {
    id: 7,
    title: "Quiz",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Ce jeu propose quatre questions et chaque question comporte quatre réponses possibles. Le score du joueur est affiché à la fin du quiz.",
    img: "./assets/img/quiz.jpg",
    link: "/projet-quiz",
  },
  {
    id: 8,
    title: "Flappy bat",
    date: "",
    languages: ["JavaScript"],
    infos:
      "Ce jeu est une étude JavaScript basée sur le principe du jeu « Flappy bird ». À vous de jouer !",
    img: "./assets/img/flappy-bat-v.jpg",
    link: "/projet-flappy-bat",
  },
  {
    id: 9,
    title: "Actus RH",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Cette série de dessins a été réalisée pour les réseaux sociaux de la Smart Base RH durant la période de crise pandémique.",
    img: "./assets/img/dessins-actus.jpg",
    link: "/projet-actu-rh",
  },
  {
    id: 10,
    title: "Visuels de com",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Exemples de visuels de communication réalisés pour la Smart Base RH.",
    img: "./assets/img/visuels-com2.jpg",
    link: "/projet-visuel-com",
  },
  {
    id: 11,
    title: "Logos",
    date: "",
    languages: ["Graphisme"],
    infos:
      "Exemples de logos réalisés pour la Smart Base RH, la paroisse et l'Institution Notre-Dame la Riche",
    img: "./assets/img/logos.jpg",
    link: "/projet-logos",
  },
  {
    id: 12,
    title: "Bandes dessinées",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Publication des bandes dessinées «Sémaphore», éditions Paquet 2005 (prix du scénario 2006 au «Festi’BD de Moulins») et «Les mauvais coups», éditions La Boîte à Bulles 2010.",
    img: "./assets/img/bandes-dessinees.jpg",
    link: "/projet-bandes-dessinees",
  },
  {
    id: 13,
    title: "Éditions jeunesse",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Exemples d’illustrations réalisées pour l’ouvrage «Quatre histoires pour petits Charentais sages» de Yves Bertin, éditions Tami 2014.",
    img: "./assets/img/illustrations-jeunesse.jpg",
    link: "/projet-editions-jeunesse",
  },
  {
    id: 14,
    title: "Pochettes de disques",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Visuels de pochettes de disques réalisés pour l’auteur-compositeur-interprète Brice.",
    img: "./assets/img/pochettes-disques.jpg",
    link: "/projet-pochettes-disques",
  },
  {
    id: 15,
    title: "Sweat-shirts",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Sélection de visuels pour sweat-shirts réalisés au profit de l’association des parents d’élèves de l’Institution Notre-Dame la Riche à Tours.",
    img: "./assets/img/sweat-shirts.jpg",
    link: "/projet-sweat-shirts",
  },
  {
    id: 16,
    title: "Planches de skate",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Visuels pour plateaux de skateboard réalisés pour le magasin «Feat Skateshop» à Saintes (17) en 2012.",
    img: "./assets/img/skate.jpg",
    link: "/projet-planches-skate",
  },
  {
    id: 17,
    title: "Aéronautique",
    date: "",
    languages: ["Illustrations"],
    infos:
      "Exemples de travaux réalisés pour un projet d'ouvrage de communication interne de l’Armée de l’air et de l’espace.",
    img: "./assets/img/aeronautique.jpg",
    link: "/projet-aeronautique",
  },
];
